<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon :icon="params.data.topjob == true ? 'check' : 'times'" />
  </div>
</template>

<script>
export default {
  name: "CellRendererTopJob"
};
</script>
